var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%","height":"100%"}},[_c('svg',{attrs:{"viewBox":"5 20 30 310"}},[_c('polyline',{staticClass:"shap",staticStyle:{"fill":"none","stroke":"rgb(151, 151, 151)","stroke-width":"4"},style:({'stroke':_vm.borderColor}),attrs:{"points":"20,100,20,0","stroke-dasharray":"2 3"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }